class Navigation {
    constructor () {
        this.scroll();
        this.mobileToggle();

        this.isLogoEnlargeable = document.querySelector('#logo').classList.contains('large');
    }

    scroll() {
        let proof = () => {
            if(window.pageYOffset > 0) {
                if(this.isLogoEnlargeable) this.shrinkLogo();
                this.shrinkNavigation();
            }
            else {
                if(this.isLogoEnlargeable) this.enlargeLogo();
                this.enlargeNavigation();
            }
        };

        window.addEventListener('scroll', (event) => {
            proof();
        });
        proof();
    }

    shrinkLogo() {
        document.querySelector('#logo').classList.remove('large');
    }

    enlargeLogo() {
        document.querySelector('#logo').classList.add('large');
    }

    shrinkNavigation() {
        document.querySelector('header').classList.add('sticky');
    }

    enlargeNavigation() {
        document.querySelector('header').classList.remove('sticky');
    }

    mobileToggle() {
        let toggle = document.querySelector('a.toggle'),
            nav = document.querySelector('nav');

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            // toggle navigation
            if(toggle.classList.contains('close')) {
                // close navigation
                toggle.classList.remove('close');
                nav.classList.remove('show');
            }
            else {
                // open navigation
                toggle.classList.add('close');
                nav.classList.add('show');
            }
            
        })
    }

}